export default "__VITE_ASSET__CoJrzlNB__"